var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667v-10h-10v10zm10.833-12.5h-2.916l-.834-.833H8.416l-.833.833H4.666V5h11.667V3.333z",
    fill: "#2065B5"
  })));
}
export default SvgBinIcon;